import { z } from "zod";
import { ErrorResponse, SuccessResponse } from "~/types/response";
import { loginSchema, resetPasswordSchema } from "../schemas";

export interface LoginSearchParams {
    redirect?: string;
    email?: string;
    status?: "success";
}

export enum FormFieldType {
    TEXT = "text",
    PASSWORD = "password",
    // EMAIL = "email",
    // NUMBER = "number",
    // DATE = "date",
    // TIME = "time",
    // DATE_TIME = "date-time",
}




export type LoginType = z.infer<typeof loginSchema>
export type ResetPasswordType = z.infer<typeof resetPasswordSchema>
export type UpdatePasswordType = {
  token: string;
  password: string;
  confirmPassword?: string
};

export type AdminLoginData = Response & {
    user_id: string;
    token: string;
}

export type AdminLoginResponse = SuccessResponse<AdminLoginData> | ErrorResponse;


export type CreateAdminData = Response & {
    user_id: string;
}

export type CreateAdminResponse = SuccessResponse<CreateAdminData> | ErrorResponse;

export type ResetData = Response & {
    status: string;
    message: string;
}


export type ResetSuccessMessage = {
    status: string
    message: string
}

export type ResetErrorMessage = {
    details: {
        message: string
    }
}

export interface UpdatePasswordSearchParams {
  token?: string;
}
